<template>
    <div class="header_notice_box">
        <van-notice-bar color="#333" background="#EEE" v-if="!isEmpty(activity_notice)">
            <div slot="left-icon" class="left_icon">
                <div class="icon icon_notice"></div>
                <div class="txt">公告</div>
                <div class="cut"></div>
            </div>
            <div class="notice_content" @click="openActivityNotice">{{activity_notice}}</div>
        </van-notice-bar>

        <van-popup v-model="activity_notice_show">
            <div class="notice_box">
                <div class="close icon icon_close" @click="closeActivityNotice"></div>
                <div class="title">
                    <div class="icon"></div>
                    <div class="text">公告</div>
                    <div class="icon"></div>
                </div>
                <div class="content">{{activity_notice}}</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import mixins_reserve from '../mixins/reserve'
    export default {
        name: "headerNoticeBox"
        ,mixins: [mixins_reserve]
        ,data: function () {
            return {
                activity_notice_show: false
            }
        }
        ,created: function() {
            this.getActivityNotice();
        }
        ,methods: {
            /**
             * 展示注意事项
             */
            openActivityNotice: function () {
                this.activity_notice_show = true;
            }
            /**
             * 关闭注意事项
             */
            ,closeActivityNotice: function () {
                this.activity_notice_show = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header_notice_box{
        position: sticky;
        left: 0;
        top: 0;
        z-index: $z_index_header;
        box-shadow: $box_shadow_up;

        .left_icon{
            display: flex;
            align-items: center;
            padding-right: .1rem;

            .icon{
                width: .48rem;
                height: .48rem;
            }
            .txt{
                font-size: .3rem;
                font-weight: bold;
                color: $color_green0;
                margin: 0 .1rem;
            }
            .cut{
                height: .3rem;
                border-right: .02rem solid $color_bdr_green0;
            }
        }

        .notice_content{
            font-size: .28rem;
        }
    }
    .notice_box{
        position: relative;
        width: 6.8rem;

        .close{
            position: absolute;
            right: .2rem;
            top: .2rem;
            z-index: $z_index_2;
            width: .6rem;
            height: .6rem;
        }
        .title{
            position: sticky;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            padding: .2rem .3rem;
            font-size: .48rem;
            font-weight: bold;
            text-align: center;

            .text{
                margin: 0 .2rem;
            }
            .icon{
                width: .2rem;
                height: .2rem;
                background-color: $color_bg_green1;
            }
        }
        .content{
            max-height: 7.5rem;
            padding: .3rem;
            font-size: .32rem;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>